import React from 'react';

export function SortPriceDown() {
  return (
    <svg
      className='fill-current'
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      viewBox='0 0 512 512'
      xmlSpace='preserve'
      width='20px'
      height='20px'
    >
      <path d='M132.792,493.448v-56.416c-36.632-1.168-73.273-11.632-94.208-25.6L54.287,356.8c27.494,16.29,58.766,25.115,90.72,25.6c36.64,0,61.649-18.032,61.649-45.936c0-26.168-20.36-43.04-63.392-58.736c-38.616-14.832-78.168-42.752-78.168-96.823c0-50.008,34.896-88.392,93.601-98.864V17.744h47.688v54.08c27.85,0.311,55.274,6.872,80.248,19.2l-15.664,53.488c-24.42-12.805-51.548-19.583-79.12-19.768c-40.712,0-55.248,20.936-55.248,40.712c0,23.84,20.936,37.216,70.4,56.992c65.136,24.424,94.208,55.832,94.208,107.585c0,49.432-34.312,93.048-98.28,103.512v59.896L132.792,493.448z' />
      <rect x='389.923' width='15.999' height='384.753' />
      <polygon points='322.432,381.256 397.92,512 473.416,381.256' />
    </svg>
  );
}
